<ion-button (click)="expanded = !expanded" expand="full">{{ 'Mobile.NewAlarm' | translate }}</ion-button>
<div *ngIf="expanded">
  <ion-button *ngFor="let item of list" expand="block" [appAlert]="count" [event]="item">
    <span>{{ item.EvtText }}</span>
    <app-alert-counter #count></app-alert-counter>
  </ion-button>
</div>
